var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import UserPlusSvg from './user-plus.icon.svg';
export const UserPlusIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: UserPlusSvg }));
_react_refresh_temp_1 = UserPlusIcon;
$RefreshReg$(_react_refresh_temp_1, "UserPlusIcon");
